const PARAGRAPH_BR_MAIN_MENU = (uuid: string, paragraphName = false, page = 0, filter = "") => `
  ${paragraphName ? `${paragraphName}: ` : ""} paragraphsDataUUID(uuid: "${uuid}", page: ${Math.max(
	0,
	page,
)}, filter: "${filter}") {
			menu(name: "main") {
				items {
					title
					originTitle
					targetBlank
        	disabled
					url {
						path
					}
				}
			}
  }
`;

export default PARAGRAPH_BR_MAIN_MENU;
